import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes/AppRoutes.js';
import { AuthProvider } from './context/AuthContext.js';
import { PlatformAdminAuthProvider } from './features/platform-admin/contexts/PlatformAdminAuthContext.js';
import { TenantProvider } from './shared/contexts/TenantContext.js';
import { SessionProvider } from './shared/contexts/SessionContext.js';
import { SecurityDataProvider } from './shared/contexts/SecurityDataContext.js';
import { SharedUIProvider } from './shared/contexts/SharedUIContext.js';
import { AutomationModeProvider } from './shared/contexts/AutomationModeContext.js';
import SessionTimeoutModal from './components/auth/SessionTimeoutModal.js';
import { MuiThemeProvider } from './theme/MuiThemeProvider.js';
import { NotificationProvider } from './context/NotificationContext.js';

function App() {
  // Provide both auth contexts so platform admin routes work on any domain (including localhost)
  // Platform admin routes use PlatformAdminAuthProvider
  // Tenant routes use AuthProvider
  return (
    <BrowserRouter>
      <MuiThemeProvider>
        <NotificationProvider>
          <PlatformAdminAuthProvider>
            <AuthProvider>
              <TenantProvider>
                <SessionProvider>
                  <SecurityDataProvider>
                    <SharedUIProvider>
                      <AutomationModeProvider>
                        <div className="min-h-screen bg-gray-900 text-white">
                          <AppRoutes />
                          <SessionTimeoutModal warningMinutes={5} />
                        </div>
                      </AutomationModeProvider>
                    </SharedUIProvider>
                  </SecurityDataProvider>
                </SessionProvider>
              </TenantProvider>
            </AuthProvider>
          </PlatformAdminAuthProvider>
        </NotificationProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  );
}

export default App;
